
import { Injectable } from '@angular/core';

import { FieldDropdown } from './field-dropdown';
import { FieldBase } from './field-base';
import { FieldTextbox } from './field-textbox';

@Injectable({
  providedIn: 'root'
})
export class FieldsListService {

  constructor() { }

  // TODO: get from a remote source of question metadata
  // TODO: make asynchronous
  getFields() {

    const fields: FieldBase<any>[] = [
/*
      new FieldDropdown({
        key: 'brave',
        label: 'Bravery Rating',
        options: [
          {key: 'solid',  value: 'Solid'},
          {key: 'great',  value: 'Great'},
          {key: 'good',   value: 'Good'},
          {key: 'unproven', value: 'Unproven'}
        ],
        order: 3
      }),
*/
      new FieldTextbox({
        key: 'lastName',
        label: 'lastName',
        value: '',
        required: false,
        order: 3
      }),
      new FieldTextbox({
        key: 'firstName',
        label: 'firstName',
        value: '',
        required: false,
        order: 1
      }),

      new FieldTextbox({
        key: 'email',
        label: 'Email',
        value: '',
        required: false,
        type: 'email',
        order: 2
      })
    ];

    return fields.sort((a, b) => a.order - b.order);
  }
}
